import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './index.css'
import { ErrorBoundary } from './components/ErrorBoundary'
import { captureInstallPrompt } from './lib/pwaInstall'
import { registerServiceWorker } from './lib/serviceWorker'

// KAN-834: приложение менеджера (PWA): окно установки ловится сразу при старте,
// service worker только в production-сборке (в dev он мешал бы горячей перезагрузке).
captureInstallPrompt()
if (import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void registerServiceWorker()
  })
}

// Initialize Sentry if DSN is provided
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_RELEASE_VERSION,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Performance monitoring
    tracesSampleRate: 0.1, // 10% of transactions

    // Session replay
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

    // Before send hook - filter sensitive data
    beforeSend(event) {
      // Remove Authorization header for privacy
      if (event.request?.headers) {
        delete event.request.headers['Authorization']
      }
      return event
    },
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
